import { render, staticRenderFns } from "./ValueListDialog.vue?vue&type=template&id=2cd9b020"
import script from "./ValueListDialog.vue?vue&type=script&lang=js"
export * from "./ValueListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports